<template>
  <div class="home">
    <v-container grid-list-md>
      <v-layout row justify-center>
        <v-flex xs12 md9>
          <v-layout column align-center justify-space-between>
            <v-flex mb-5 mt-5>
              <img
                :src="require('@/assets/hil-logo-text-white.png')"
                width="200px"
              />
            </v-flex>
            <v-flex>
              <v-card
                class="px-2 py-2"
                style="min-width: 450px; max-width: 90vw"
              >
                <h2 class="mb-2">
                  {{ isCreate ? "Création" : "Renouvellement" }} de mot de passe
                </h2>
                <div v-if="noToken">
                  Aucune demande correspondante n'a été trouvée
                </div>
                <div v-else>
                  <v-text-field
                    v-model="newPassword"
                    label="Nouveau (minuscules, majuscules et chiffres)"
                    type="password"
                    ref="new1"
                    v-validate="{
                      required: true,
                      min: 8,
                      regex: /^(?=.*[A-z])(?=.*[A-Z])(?=.*[0-9])\S{8,}$/
                    }"
                    data-vv-name="new1"
                    style="width: 100%"
                    :error-messages="errors.collect('new1')"
                  ></v-text-field>
                  <v-text-field
                    v-model="newPasswordBis"
                    label="Confirmez le mot de passe"
                    type="password"
                    v-validate="'required|confirmed:new1'"
                    data-vv-name="new2"
                    :error-messages="errors.collect('new2')"
                  ></v-text-field>
                  <div class="d-flex justify-center mt-2">
                    <v-btn color="accent" :loading="saveLoading" @click="save()"
                      >Valider</v-btn
                    >
                  </div>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <v-snackbar v-model="saveError"> Une erreur a eu lieu </v-snackbar>
  </div>
</template>

<script>
import { fetchHil } from "../utils";

export default {
  name: "passwordrenewal",
  components: {},
  data() {
    return {
      loading: true,
      newPassword: "",
      newPasswordBis: "",
      noToken: false,
      saveError: false,
      saveLoading: false
    };
  },
  computed: {
    isCreate() {
      return this.$route.meta.create;
    }
  },
  async mounted() {
    try {
      await this.$store.dispatch("logout");
    } catch (e) {}
    const { id, token } = this.$route.query;
    const resp = await fetchHil("/user/checkPasswordToken", {
      method: "POST",
      body: { id, token }
    });
    if (!resp.ok) {
      this.noToken = true;
    }
    this.loading = false;
  },
  methods: {
    async save() {
      if (this.saveLoading || !(await this.$validator.validateAll())) {
        return;
      }
      const { id, token } = this.$route.query;
      this.saveLoading = true;
      try {
        const resp = await fetchHil("/user/renewPassword", {
          method: "POST",
          body: { id, token, newPassword: this.newPassword }
        });

        if (!resp.ok) {
          throw new Error("request error");
        }
        this.saveLoading = false;
        this.$router.push("/?renew=ok");
      } catch (e) {
        this.saveError = true;
        this.saveLoading = false;
      }
    }
  }
};
</script>

<style>
.motto {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  text-align: center;
  color: white;
  font-size: 18pt;
}
</style>
